/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { PropertyType, PropertyTypeUtil } from "./property-type";

export class RuleCondition {
  id: number;
  source: string;
  sourceType: Type;
  property: string;
  propertyType: PropertyType;
  propertyOperator: Operator;
  propertyValue: string;
  operator: Operator;
  value: string;
}

export enum Operator {
  EQUAL = "EQUAL",
  NOT_EQUAL = "NOT_EQUAL",
  LESS_THAN = "LESS_THAN",
  GREATER_THAN = "GREATER_THAN",
  COUNT_EQUAL = "COUNT_EQUAL",
  COUNT_GREATER_THAN = "COUNT_GREATER_THAN",
  COUNT_LESS_THAN = "COUNT_LESS_THAN",
  EXISTS = "EXISTS",
  NOT_EXISTS = "NOT_EXISTS",
  IN_GROUP = "IN_GROUP",
  NOT_IN_GROUP = "NOT_IN_GROUP",
  MATCHES = "MATCHES",
  NOT_MATCHES = "NOT_MATCHES",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS",
  HAS_PROPERTY_WITH_VALUE = "HAS_PROPERTY_WITH_VALUE"
}

export enum Type {
  EVENT = "EVENT",
  ASSET = "ASSET",
  TAG = "TAG",
  OBJECT = "OBJECT",
  OBJECT_INSTANCE = "OBJECT_INSTANCE",
  USER = "USER",
  READER = "READER"
}

export class OperatorUtil {
    static getOperatorsForPropertyType(propertyType: PropertyType): Operator[] {
        const operators: Operator[] = [];
        operators.push(Operator.EQUAL);
        operators.push(Operator.NOT_EQUAL);
        
        if (PropertyTypeUtil.isNumber(propertyType)) {
            operators.push(Operator.LESS_THAN);
            operators.push(Operator.GREATER_THAN);
        }
        
        if (PropertyTypeUtil.isString(propertyType)) {
            operators.push(Operator.MATCHES);
            operators.push(Operator.NOT_MATCHES);
        }
        
        if (PropertyTypeUtil.isReference(propertyType)) {
            operators.push(Operator.EXISTS);
            operators.push(Operator.NOT_EXISTS);
            operators.push(Operator.COUNT_EQUAL);
            operators.push(Operator.COUNT_GREATER_THAN);
            operators.push(Operator.COUNT_LESS_THAN);
            operators.push(Operator.IN_GROUP);
            operators.push(Operator.NOT_IN_GROUP);
        }

        switch (propertyType) {
            case PropertyType.ANTENNA_REFERENCE:
            case PropertyType.LOCATION_REFERENCE: 
            case PropertyType.OBJECT_REFERENCE:
            case PropertyType.READER_REFERENCE: 
            case PropertyType.TAG_REFERENCE: 
            case PropertyType.ZONE_REFERENCE:  
            case PropertyType.DRIVEROBJECT_REFERENCE: 
            case PropertyType.SERVICE_REFERENCE: 
            case PropertyType.SERVEROBJECT_REFERENCE: 
                operators.push(Operator.HAS_PROPERTY_WITH_VALUE);
        }
        
        return operators;
    }
    
    static getOperatorLabel(operator: Operator): string {
        switch (operator) {
            case Operator.EQUAL:
                return "is";
            case Operator.NOT_EQUAL:
                return "is not";
            case Operator.LESS_THAN:
                return "less than";
            case Operator.GREATER_THAN:
                return "greater than";
            case Operator.EXISTS:
                return "is present";
            case Operator.NOT_EXISTS:
                return "is not present";
            case Operator.COUNT_EQUAL:
                return "count is";
            case Operator.COUNT_GREATER_THAN:
                return "count greater than";
            case Operator.COUNT_LESS_THAN:
                return "count less than";
            case Operator.IN_GROUP:
                return "in group";
            case Operator.NOT_IN_GROUP:
                return "not in group";
            case Operator.MATCHES:
                return "matches";
            case Operator.NOT_MATCHES:
                return "doesn't match";
            case Operator.HAS_PROPERTY_WITH_VALUE: 
                return "has Data for Property";
            default: 
                return operator == null? "*NULL OPERATOR*" : operator.toString();
        }
    }
}
